import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { env } from '../../configs/EnvironmentConfig'
import { AUTH_TOKEN } from 'constants/AuthConstant';

export const initialState = {
    modes: null,
    stops: null,
    users: null,
    routes: null,
    loading: false,
    message: '',
    isError: false
}

const path = (baseUrl, endpoint) => {
    return `${baseUrl}/mission-control-service/v1/${endpoint}`;
};

export const getModes = createAsyncThunk('/modes', async () => {
    const url = path(env.MISSION_CONTROL_SERVICE, 'transupport/modes');
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'authorization': localStorage.getItem(AUTH_TOKEN)
        }
    })
    return response.json();
});

export const getStops = createAsyncThunk('/stops', async (data) => {
    const { mode } = data
    const url = path(env.MISSION_CONTROL_SERVICE, `transupport/modes/${mode}/stops`);
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'authorization': localStorage.getItem(AUTH_TOKEN)
        }
    })
    return response.json();
});

export const getRoutes = createAsyncThunk('/routes', async (data) => {
    const { mode } = data
    const url = path(env.MISSION_CONTROL_SERVICE, `transupport/modes/${mode}/routes`);
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'authorization': localStorage.getItem(AUTH_TOKEN)
        }
    })
    return response.json();
});

export const triggerRefresh = createAsyncThunk('/metaRefresh', async (data) => {
    const url = path(env.MISSION_CONTROL_SERVICE, 'transupport/metaRefresh');
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            'authorization': localStorage.getItem(AUTH_TOKEN)
        },
        body: JSON.stringify(data)
    })
    return response.json();
});

export const missionControlServiceSlice = createSlice({
    name: 'missionControlService',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getModes.pending, (state)=> {
                state.loading = true
                state.isError = false
                state.modes = []
                state.message = 'Request sent'
            })
            .addCase(getModes.rejected, (state) => {
                state.loading = false
                state.isError = true
                state.modes = []
                state.message = 'Request failed'
            })
            .addCase(getModes.fulfilled, (state, action) => {
                state.loading = false
                state.isError = false
                state.modes = action.payload.modes
                state.message = 'Request successful'
            })
            .addCase(getStops.pending, (state)=> {
                state.loading = true
                state.isError = false
                state.stops = []
                state.message = 'Request sent'
            })
            .addCase(getStops.rejected, (state) => {
                state.loading = false
                state.isError = true
                state.stops = []
                state.message = 'Request failed'
            })
            .addCase(getStops.fulfilled, (state, action) => {
                state.loading = false
                state.isError = false
                state.stops = action.payload.stops
                state.message = 'Request successful'
            })
            .addCase(getRoutes.pending, (state)=> {
                state.loading = true
                state.isError = false
                state.routes = []
                state.message = 'Request sent'
            })
            .addCase(getRoutes.rejected, (state) => {
                state.loading = false
                state.isError = true
                state.routes = []
                state.message = 'Request failed'
            })
            .addCase(getRoutes.fulfilled, (state, action) => {
                state.loading = false
                state.isError = false
                state.routes = action.payload.routes
                state.message = 'Request successful'
            })
    }
});

export default missionControlServiceSlice.reducer
